import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { connect } from '@common/components/base.component';
import Panel from '@common/components/panel/panel.component';
import DDadosItem from '@common/components/ddados/ddados.item';
import DDados from '../emissao.ddados';
import api from '../service/emissao.service';
import Form from '@common/components/validation/form.validation';
import apiSelecaoItemExterno from '../service/selecaoItemExterno.service';
import EnumTipoParametroRelatorio from '@common/components/relatorioGerencial/enumTipoParametroRelatorio';
import EnumSistemasRelatorio from '@common/components/relatorioGerencial/enumSistemasRelatorio';
import _ from 'lodash';

function EmissaoForm(props) {
  const { selecaoItens, modulo, routerManager } = props;

  const { Campos } = DDados;

  const [state, setState] = useState({
    ReturnApi: false,
    Modulo: null,
    ModuloList: null,
    Relatorio: [],
    RelatorioState: null,
    Campo: [],
    RelatorioCodigo: null,
    IdSelecao: null,
    ProcessarSegundoPlano: false,
    GeneratingIdSelecao: false,
    LoadingDots: '',
    Formato: 'PDF',
  });

  const setStateEmissao = useCallback((stateEmissao) => {
    setState((prevState) => ({ ...prevState, ...stateEmissao }));
  }, []);

  const buttonImprimir = {
    chilldren: 'Imprimir',
    onClick: async (item) => {
      var itensImpressao = mapearItensImpressao(item);

      await imprimirRelatorio(itensImpressao);
    },
    classNameIcon: 'fas fa-print',
    className: 'btn btn-primary float-right',
    type: 'submit',
  };

  const mapearItensImpressao = (item) => {
    state.Campo.forEach((campo) => {
      var isCheckDinamico = campo.Tipo == 'checkbox' && campo.Itens?.length > 0;

      if (isCheckDinamico) {
        campo.Itens.forEach((itemCampo) => {
          delete item[campo.Parametro + itemCampo.Value];
        });

        delete item[campo.Parametro + 'Todos'];

        item[campo.Parametro] =
          Array.isArray(campo.ItensSelecionados) && campo.ItensSelecionados?.length > 0
            ? campo.ItensSelecionados.join(',')
            : '';
      }
    });

    var campos = Object.keys(item);

    campos.forEach((x) => {
      if (item[x] == '' && checkCampoObrigatorio(x)) {
        item[x] = undefined;
      }
    });

    return item;
  };

  const onTick = useCallback(() => {
    if (state.GeneratingIdSelecao) {
      setStateEmissao({ IdSelecao: `Gerando IdSelecao${state.LoadingDots}` });
      handleLoadingDots();
    }
  }, [state.GeneratingIdSelecao, state.LoadingDots, setStateEmissao]);

  const handleLoadingDots = () => {
    if (state.LoadingDots.length < 3) setStateEmissao({ LoadingDots: state.LoadingDots + '.' });
    else setStateEmissao({ LoadingDots: '' });
  };

  const checkCampoObrigatorio = (campo) => {
    return (
      state.Campo?.filter(
        (x) =>
          (!x.Grupo && x.Parametro == campo && (x.Obrigatorio == 'NAO' || !x.Obrigatorio)) ||
          (x.Grupo &&
            x.ParametrosAgrupados?.filter((p) => p.Parametro == campo && (p.Obrigatorio == 'NAO' || !p.Obrigatorio))
              ?.length > 0)
      ).length > 0
    );
  };

  useEffect(() => {
    getModuloEmissaoRelatorio();

    if (props.componentUrl) {
      getIdSelecao();

      const parameters = {
        IdSistema: 21,
        componentUrl: props.componentUrl,
      };

      api
        .relatorioSuggestion(parameters)
        .then((res) => {
          setStateEmissao({
            Relatorio: res.data,
          });
        })
        .catch((err) => {});
    }
  }, []);

  const getIdSelecao = () => {
    setStateEmissao({ GeneratingIdSelecao: true });

    let myInterval = (myInterval = setInterval(() => {
      onTick();
    }, 500));

    const idSistema = sessionStorage.getItem('SISTEMA');
    const appConfig = window.appConfig;

    let promisseGenerateId = undefined;

    if (idSistema == EnumSistemasRelatorio.SST && appConfig.useReportDesignerSST)
      promisseGenerateId = apiSelecaoItemExterno.saveSST(selecaoItens);
    else if (idSistema == EnumSistemasRelatorio.TB && appConfig.useReportDesignerTB)
      promisseGenerateId = apiSelecaoItemExterno.saveTB(selecaoItens);

    if (promisseGenerateId) {
      promisseGenerateId
        .then((res) => {
          setStateEmissao({
            IdSelecao: res.data,
            GeneratingIdSelecao: false,
          });

          clearInterval(myInterval);
        })
        .catch((err) => {
          _alert.error(err.data.Error);

          clearInterval(myInterval);
          setStateEmissao({ GeneratingIdSelecao: false });
        });
    }
  };

  async function imprimirRelatorio(item) {
    let isBackground = state.ProcessarSegundoPlano;

    if (state.RelatorioCodigo) {
      if (state.IdSelecao) item = { ...item, IdSelecao: state.IdSelecao };

      if (selecaoItens?.length > 100) {
        const confirm = await _alert.confirm(
          'Deseja imprimir mais do que 100 registros? O relatório será processado em segundo plano',
          'Processar em segundo plano'
        );

        if (!confirm) return;
        else _alert.info('O relatório será gerado em segundo plano');

        isBackground = confirm;
      } else if (isBackground) {
        _alert.info('O relatório será gerado em segundo plano');
      }

      const dto = {
        codigoRelatorio: state.RelatorioCodigo,
        parameters: item,
        isBackground,
        modulo,
        formato: state.Formato,
      };

      api
        .postGerarRelatorio(dto)
        .then((res) => {
          if (!isBackground) {
            if (res.data.Success) {
              window.open(res.data.Url, '_blank');
            } else {
              _alert.error(res.data.Error);
            }
          }
        })
        .catch((err) => {
          _alert.error(err.data.Error);
        });
    } else {
      _alert.error('Selecione um relatório para imprimir.');
    }
  }

  const getModuloEmissaoRelatorio = () => {
    api
      .moduloEmissaoRelatorio()
      .then((res) => {
        setStateEmissao({
          ModuloList: res.data,
        });
      })
      .catch((err) => {});
  };

  const onChangeModulo = (item) => {
    const parameters = {
      moduloId: item,
      IdSistema: 21,
      componentUrl: props.componentUrl,
      removeComIdSelecao: true,
    };

    api
      .relatorioSuggestion(parameters)
      .then((res) => {
        setStateEmissao({
          Relatorio: res.data,
        });
      })
      .catch((err) => {});
  };

  const relatorioSuggestionOnChange = (item) => {
    if (!!item.Id && !!item.CodigoString) {
      api
        .getParametros(item.Id)
        .then((res) => {
          var lista = res.data.dataList;

          lista.forEach((item) => {
            if (item.ParametrosAgrupados) {
              item.ParametrosAgrupados.forEach((x) => {
                x.Tipo = verificaItem(x.Tipo);
              });
            } else {
              item.Tipo = verificaItem(item.Tipo);
            }
          });

          setStateEmissao({
            Campo: lista,
            RelatorioCodigo: item.CodigoString,
          });
        })
        .catch((err) => {});
    }
  };

  const verificaItem = (item) => {
    switch (item) {
      case EnumTipoParametroRelatorio.Inteiro:
        return 'number';
      case EnumTipoParametroRelatorio.Decimal:
        return 'decimal';
      case EnumTipoParametroRelatorio.Texto:
        return 'text';
      case EnumTipoParametroRelatorio.Data:
        return 'date';
      case EnumTipoParametroRelatorio.DataHora:
        return 'datetime';
      case EnumTipoParametroRelatorio.Logico:
        return 'checkbox';
      case EnumTipoParametroRelatorio.Tabela:
        return 'combobox';
      case EnumTipoParametroRelatorio.Consulta:
        return 'combobox';
      case EnumTipoParametroRelatorio.ConsultaCheckbox:
        return 'checkbox';
      default:
        return 'text';
    }
  };

  const onChangeCheckboxItem = (item, value) => {
    var parametro = state.Campo.find((campo) => campo.Parametro == item.Parametro);

    if (parametro) {
      var novosItensSelecionados = Array.isArray(parametro.ItensSelecionados) ? parametro.ItensSelecionados : [];

      if (value == true) novosItensSelecionados.push(item.Value);
      else novosItensSelecionados = novosItensSelecionados.filter((x) => x != item.Value);

      var campos = _.cloneDeep(state.Campo);

      campos.find((x) => x.Parametro == parametro.Parametro).ItensSelecionados = novosItensSelecionados;

      setStateEmissao({
        Campo: campos,
      });
    }
  };

  const onChangeTodos = (item, value) => {
    var parametro = state.Campo.find((campo) => campo.Parametro == item.Parametro);

    if (parametro) {
      var campos = _.cloneDeep(state.Campo);

      campos.find((x) => x.Parametro == parametro.Parametro).ItensSelecionados =
        value == true ? parametro.Itens.map((item) => item.Value) : [];

      setStateEmissao({
        Campo: campos,
      });
    }
  };

  const getParametroCheckboxDinamico = (parametro) => {
    if (parametro?.Itens?.length > 0) {
      var parametrosCombobox = [];

      parametro.Itens.map((item) => {
        parametrosCombobox.push({
          ...parametro,
          Itens: undefined,
          Value: item.Value,
          Tipo: 'checkbox',
          Label: item.Text,
          Tooltip: item.Text,
          onChange: onChangeCheckboxItem,
        });
      });

      parametrosCombobox = parametrosCombobox.filter((x) => x.Value != 'Todos');

      parametrosCombobox.push({
        ...parametro,
        Itens: undefined,
        Value: 'Todos',
        Tipo: 'checkbox',
        Label: 'Todos',
        Tooltip: 'Todos',
        onChange: onChangeTodos,
      });

      return parametrosCombobox;
    }

    return parametro;
  };

  const renderParametro = (item, index) => {
    if (item.Tipo == 'checkbox' && item.Itens?.length > 0) {
      var parametroCheckbox = getParametroCheckboxDinamico(item);

      if (Array.isArray(parametroCheckbox)) {
        return (
          <Row>
            <Col lg={12}>
              <Panel title={item.Label}>
                <Row>
                  {parametroCheckbox.map((parametro, indexParametro) => (
                    <Col lg={parseInt(item.Label?.length / 10) > 2 ? parseInt(item.Label.length / 10) : 2}>
                      {renderParametroItem(parametro, indexParametro)}
                    </Col>
                  ))}
                </Row>
              </Panel>
            </Col>
          </Row>
        );
      } else {
        return renderParametroItem(item, index);
      }
    } else {
      return renderParametroItem(item, index);
    }
  };

  const renderParametroItem = (item, index) => {
    const parametroCampo = state.Campo.find((x) => x.Parametro == item.Parametro);
    const isCheckDinamico = item.Tipo == 'checkbox' && parametroCampo?.Itens?.length > 0;
    let nameParametro = item.Parametro;

    let propsCheckDinamico = {};

    if (isCheckDinamico) {
      nameParametro = nameParametro + item.Value;

      var itensSelecionados = parametroCampo.ItensSelecionados;

      if (Array.isArray(itensSelecionados) && item.Value != 'Todos') {
        const selecionado = itensSelecionados.find((x) => x == item.Value) ? true : false;

        propsCheckDinamico = { state: { [nameParametro]: selecionado } };
      }
    }

    return (
      <Col lg={item.TamanhoEmTela > 12 ? 12 : item.TamanhoEmTela} key={index}>
        <DDadosItem
          name={nameParametro}
          Tipo={item.Tipo}
          DataFutura={item.Tipo == 'date'}
          Label={item.Label}
          Placeholder={' '}
          displaySizeLimit={item.Tipo == 'combobox' ? '150' : undefined}
          utilizaTooltipOpcao={true}
          Tooltip={item.Tooltip}
          Tamanho={item.TamanhoMaximo}
          CasasDecimais={item.Precisao > 6 ? 6 : item.Precisao}
          Obrigatorio={item.Tipo == 'checkbox' ? false : item.Obrigatorio == 'SIM' ? true : false}
          LabelSpace={item.Tipo == 'checkbox' ? true : false}
          LabelSpaceVertical={item.Tipo == 'checkbox' ? true : false}
          itens={item.Tipo == 'combobox' || item.Tipo == 'typeahead' ? item.Itens : null}
          valueField={'Value'}
          textField={'Text'}
          labelKey={'Text'}
          valueKey={'Value'}
          Desabilitado={props.componentUrl && item.Parametro.toLowerCase() == 'idselecao' ? true : false}
          state={
            props.componentUrl && item.Parametro.toLowerCase() == 'idselecao'
              ? { [item.Parametro]: state.IdSelecao }
              : (item.Obrigatorio?.toUpperCase() || !item.Obrigatorio) == 'NAO'
              ? { [item.Parametro]: undefined }
              : null
          }
          onChange={(value) => (item.onChange ? item.onChange(item, value) : undefined)}
          ItensSelecionados={isCheckDinamico ? [] : undefined}
          {...propsCheckDinamico}
        />
      </Col>
    );
  };

  return (
    <Fragment>
      <Form>
        <Row>
          {!props.componentUrl && (
            <Col lg={4}>
              <DDadosItem
                name="Modulo"
                {...Campos.Modulo}
                state={state}
                valueField="Id"
                textField="Nome"
                itens={state.ModuloList}
                onChange={(item) => {
                  onChangeModulo(item);
                }}
              />
            </Col>
          )}
          <Col lg={6}>
            <DDadosItem
              name="Relatorio"
              {...Campos.Relatorio}
              itens={state.Relatorio}
              onChange={(item) => relatorioSuggestionOnChange(item)}
            />
          </Col>
          <Col lg={2}>
            <DDadosItem
              name="Formato"
              {...Campos.Formato}
              state={state}
              onChange={(value) => setStateEmissao({ Formato: value })}
            />
          </Col>
          <Col lg={4} style={{ marginTop: '22px' }}>
            <DDadosItem
              name="ProcessarSegundoPlano"
              {...Campos.ProcessarSegundoPlano}
              itens={state.ProcessarSegundoPlano}
              onChange={(value) => setStateEmissao({ ProcessarSegundoPlano: value })}
            />
          </Col>
        </Row>
      </Form>
      <Form
        onCustomButtom={[{ ...buttonImprimir, disabled: state.GeneratingIdSelecao }]}
        formControl={true}
        routerManager={routerManager}
        onCancel={props.onCancel}
        boxForm
      >
        {
          <Panel title="Parâmetros">
            <Row>
              {state.Campo.map((itemParametro, indexParametro) => (
                <Fragment>
                  {itemParametro.Grupo ? (
                    <Col lg={12}>
                      <Panel title={itemParametro.Grupo} key={indexParametro}>
                        <Row>
                          {itemParametro.ParametrosAgrupados.map((item, index) => renderParametro(item, index))}
                        </Row>
                      </Panel>
                    </Col>
                  ) : (
                    renderParametro(itemParametro, indexParametro)
                  )}
                </Fragment>
              ))}
            </Row>
          </Panel>
        }
      </Form>
    </Fragment>
  );
}

export default connect({
  actions: {},
  selectors: {},
})(EmissaoForm);
